import React from "react";
import TabDynamic from "../../shared/components/tabs";
import { Tabs_List } from "./model";
import { Box, spacing } from "@mui/system";
import SignIn from "../signin/SignIn";
import { boardContext } from "../../App";

function ClientRegister() {
  const { config } = React.useContext(boardContext);
  const token: any = config?.getToken();
  const userRole: string = config?.getRole();
  // const tab = Tabs_List;

  // const handleAuth = (auth: boolean) => {
  //     setAuth(auth);
  // }

  const tabLabels = ['Kanban', 'Action'];

  const roleBasedTabs:any = {
    Admin: Tabs_List,
    Auditor: filterTabsByRole(),
  };

  function filterTabsByRole() {
    return Tabs_List.filter(tab => tabLabels.includes(tab.label));
  }

  const filteredTabs = roleBasedTabs[userRole] || [];

  return (
    <>
      {!token ? (
        <SignIn />
      ) : (
        <Box sx={{ mt: "1rem" }}>
          {/* <h3 className='mb-4'>Client Register</h3> */}
          <TabDynamic tabs={filteredTabs} />
        </Box>
      )}
    </>
  );
}

export default ClientRegister;
